import { GetFeatureFlags } from '@/connection/feature-flags';
import { store } from '@/store/main';
import { setFeatureFlags } from '@/store/slices/feature-flags';
import blAuth from '@/connection/bl-auth/bl-auth';
import { overrideCurrentChannel, setAuthTokens } from '@/store/slices/user';
import { loadChannels } from '@/store/slices/channels';
import { loadTemplates } from '@/connection/loaders/templates';
import { loadProject } from '@/store/slices/project';

let authReadyResolver: (() => void) | null = null;

export const authReady = new Promise<void>((resolve) => {
  authReadyResolver = resolve;
});

export const mainLoader = async ({ request }: { request: Request }): Promise<Response> => {
  try {
    const forceProjectLoad = request.url.match(
      /\/project\/edit\/(?<projectUuid>[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})/
    );

    const loadFeatureFlags = async () => {
      const featureFlags = await GetFeatureFlags();
      store.dispatch(setFeatureFlags(featureFlags));
    };

    const auth = async () => {
      await blAuth.handleRedirected();
      const url = new URL(window.location.href);
      let theme = undefined;

      if (url.pathname.startsWith('/webinarplus')) {
        theme = 'webinarplus';
      }
      if (blAuth.refreshToken) {
        await blAuth.refresh();
        blAuth.initializeActivityTracker({ refreshOnInterval: true });
      } else {
        blAuth.redirectToSignIn({ redirect_uri: window.location.href, theme });
      }

      store.dispatch(
        setAuthTokens({
          idToken: blAuth.idToken as string,
          refreshToken: blAuth.refreshToken as string,
        })
      );
      store.dispatch(loadChannels({ useCache: true }));
      const projectUuid = forceProjectLoad?.groups?.projectUuid;
      if (forceProjectLoad && projectUuid) {
        await store.dispatch(
          loadProject({
            uuid: projectUuid,
            returnStoreStateIfExists: false,
          })
        );
        const project = store.getState().project;
        if (project.workingProject?.channel) {
          store.dispatch(overrideCurrentChannel(project.workingProject.channel));
        }
      }
      authReadyResolver?.();
    };

    // we don't need to await this one because it'll block the rest of the UI
    // however we DO want this to be loaded as soon as the app loads
    if (!forceProjectLoad) {
      loadTemplates(request).catch(console.error);
    }

    await Promise.all([loadFeatureFlags(), auth()]);

    if (forceProjectLoad) {
      loadTemplates(request).catch(console.error);
    }
    return new Response(null, { status: 200 });
  } catch (error) {
    console.error(error);
    authReadyResolver?.();
    return new Response(null, { status: 500 });
  }
};
